import script from "./NumberIncrement.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberIncrement.vue?vue&type=script&setup=true&lang=js"

import "./NumberIncrement.vue?vue&type=style&index=0&id=22870082&lang=scss"

const __exports__ = script;

export default __exports__